import { YesNo } from '@uplift/types';
import { RadioControl } from '@uplift/ui-v2';
import { useSectionStyles } from '../sections/styles';
import clsx from 'clsx';

export type YesNoRadioControlProps = {
  baseName: string;
  label: string;
  fullName?: string;
  inline?: true;
};

const values = [ YesNo.Yes, YesNo.No ];

export const YesNoRadioControl: React.VFC<YesNoRadioControlProps> = ({ baseName, label, fullName, inline }) => {
  const { classes } = useSectionStyles();

  const name = fullName ?? `${baseName}YesNo`;

  return (
    <RadioControl
      name={name}
      label={label}
      values={values}
      row
      className={clsx([ classes.radioMargin, {
        [classes.inlineRadio]: inline
      } ])}
      color="secondary"
      inline={inline}
      hideHelper={inline}
    />
  );
};

export type YesNoRadioControlInlineProps = {
  name: string;
  label: string;
};
